import { ref, computed, onMounted, onUnmounted } from "vue";
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
function useScreenSize() {
  const initialWidth = typeof window !== "undefined" ? window.innerWidth : breakpoints.xl;
  const windowWidth = ref(initialWidth);
  const isSmUp = computed(() => windowWidth.value >= breakpoints.sm);
  const isMdUp = computed(() => windowWidth.value >= breakpoints.md);
  const isLgUp = computed(() => windowWidth.value >= breakpoints.lg);
  const isXlUp = computed(() => windowWidth.value >= breakpoints.xl);
  const is2xlUp = computed(() => windowWidth.value >= breakpoints["2xl"]);
  const isSmDown = computed(() => windowWidth.value < breakpoints.sm);
  const isMdDown = computed(() => windowWidth.value < breakpoints.md);
  const isLgDown = computed(() => windowWidth.value < breakpoints.lg);
  const isXlDown = computed(() => windowWidth.value < breakpoints.xl);
  const isMobile = computed(() => isMdDown.value);
  const isTablet = computed(() => isMdUp.value && isLgDown.value);
  const isDesktop = computed(() => isLgUp.value);
  let resizeObserver;
  const handleResize = (entries) => {
    const bodyEntry = entries[0];
    if (bodyEntry) {
      windowWidth.value = bodyEntry.contentRect.width;
    }
  };
  onMounted(() => {
    if (typeof window === "undefined" || typeof ResizeObserver === "undefined") return;
    resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(document.body);
  });
  onUnmounted(() => {
    resizeObserver?.disconnect();
  });
  return {
    windowWidth,
    isSmUp,
    isMdUp,
    isLgUp,
    isXlUp,
    is2xlUp,
    isSmDown,
    isMdDown,
    isLgDown,
    isXlDown,
    isMobile,
    isTablet,
    isDesktop
  };
}
export {
  breakpoints,
  useScreenSize
};
//# sourceMappingURL=useScreenSize.js.map
